module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tray collision",
    class: [{
      active: _vm.isActive
    }]
  }, [(_vm.collision.date) ? _c('h2', {
    staticClass: "tray-h2 collision-h2"
  }, [_vm._v("\n        " + _vm._s(_vm.collision.date) + " "), (_vm.collision.time) ? _c('span', [_vm._v("@ " + _vm._s(_vm.collision.time))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "material-icons tray-icon-close",
    on: {
      "click": _vm.clearCollision
    }
  }, [_vm._v("close")])]) : _c('div', {
    staticClass: "tray-instructions"
  }, [_vm._v("\n        Loading collision...\n    ")]), _vm._v(" "), (_vm.collision.location) ? _c('h3', {
    staticClass: "tray-h3 collision-h3"
  }, [_vm._v("\n        " + _vm._s(_vm.collision.location) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.collision.date) ? _c('div', {
    staticClass: "l-clearfix collision-fields"
  }, [(_vm.collision.people) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.collision.people) + " " + _vm._s(_vm.collision.people > 1 ? 'people' : 'person') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.pedestrians) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_walk")]), _vm._v(" " + _vm._s(_vm.collision.pedestrians) + " " + _vm._s(_vm.collision.pedestrians > 1 ? 'pedestrians' : 'pedestrian') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.cyclists) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_bike")]), _vm._v(" " + _vm._s(_vm.collision.cyclists) + " " + _vm._s(_vm.collision.cyclists > 1 ? 'cyclists' : 'cyclist') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.vehicles) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_car")]), _vm._v(" " + _vm._s(_vm.collision.vehicles) + " " + _vm._s(_vm.collision.vehicles > 1 ? 'vehicles' : 'vehicle') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.injuries) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Injuries")]), _vm._v(" " + _vm._s(_vm.collision.injuries) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.serious_injuries) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Serious injuries")]), _vm._v(" " + _vm._s(_vm.collision.serious_injuries) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.fatalities) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Fatalities")]), _vm._v(" " + _vm._s(_vm.collision.fatalities) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.light_condition) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Light conditions")]), _vm._v("\n            " + _vm._s(_vm.collision.light_condition) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.hitparkedcar) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Hit parked car?")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.road_condition) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Road conditions")]), _vm._v("\n            " + _vm._s(_vm.collision.road_condition) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.speeding) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Speeding")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.under_influence) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Under the influence of drugs or alcohol")]), _vm._v(" Yes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.weather) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Weather")]), _vm._v("\n            " + _vm._s(_vm.collision.weather) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.address_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Address type")]), _vm._v("\n            " + _vm._s(_vm.collision.address_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.coldetkey) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Collision detail key")]), _vm._v("\n            " + _vm._s(_vm.collision.coldetkey) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.collision_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Collision type")]), _vm._v("\n            " + _vm._s(_vm.collision.collision_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.junction_type) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Junction type")]), _vm._v("\n            " + _vm._s(_vm.collision.junction_type) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.inattention) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('span', {
    staticClass: "tray-label"
  }, [_vm._v("Due to inattention?")]), _vm._v(" " + _vm._s(_vm.collision.inattention) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.inckey) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Incident key")]), _vm._v("\n            " + _vm._s(_vm.collision.inckey) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.reportno) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Report number")]), _vm._v("\n            " + _vm._s(_vm.collision.reportno) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.sdot) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("SDOT code " + _vm._s(_vm.collision.sdot.collision_code))]), _vm._v(" "), (_vm.collision.sdot.collision_title) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.collision.sdot.collision_title) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.collision.severity.code) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("Severity code " + _vm._s(_vm.collision.severity.code))]), _vm._v("\n            " + _vm._s(_vm.collision.severity.description) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.spd_case_number) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("SPD case number")]), _vm._v("\n            " + _vm._s(_vm.collision.spd_case_number) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.collision.state_collision_code) ? _c('div', {
    staticClass: "collision-field"
  }, [_c('div', {
    staticClass: "tray-label"
  }, [_vm._v("State collision code")]), _vm._v("\n            " + _vm._s(_vm.collision.state_collision_code) + "\n        ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cadca68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collisions/Collision.vue
// module id = 447
// module chunks = 1